import DimensiHeadSuper from "../../../../../components/categories/siakad/laporan_adab/penilaian/HomeHeadSuperNew";
export default function Home() {
  
  return (
    <DimensiHeadSuper />
  );
}
